import React from "react";
import stylesPc from "./Footer.module.css";
import stylesSp from "./Footer_SP.module.css";
import { IsDevice } from "../../../../components/function/useDeviceFlag";
// import PuiTypography from "../../../../components/elements/PuiTypography";


function Footer() {
    // レスポンシブ対応：ブラウザサイズによるCSSファイルの切り替え
    const styles = IsDevice("desktop") ? stylesPc : stylesSp;
    
    return (
        <footer className={styles.footer}>
            {/* <div className={styles.link}>
                <a href="/homepage">ホーム</a>
                |
                <a href="/?">運営会社</a>
                |
                <a href="/?">お問い合わせ</a>
                |
                <a href="/?">リリース情報</a>
            </div> */}
            {/* <div className={styles.content}>
                <PuiTypography size={14} color="secondary-font">
                    Copyright &copy; 2021 Pactera Technology Japan Ltd. All rights reserved.
                </PuiTypography>
            </div> */}
        </footer>
    );
}

export default Footer;
